import { useState } from "react";
import { toast } from "sonner";
import { Loader2, CreditCard } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { initPayment } from "../../lib/api";

const inputCls = "w-full bg-[#FAF9F6] border border-[#D1CFC7] focus:border-[#2C402E] px-3 py-2.5 outline-none font-body text-sm";
const COUNTRIES = [["CM", "Cameroun"], ["CI", "Côte d'Ivoire"], ["SN", "Sénégal"], ["GA", "Gabon"], ["CG", "Congo"], ["CD", "RD Congo"], ["TD", "Tchad"], ["CF", "Centrafrique"], ["GQ", "Guinée équatoriale"], ["BJ", "Bénin"], ["TG", "Togo"], ["BF", "Burkina Faso"], ["ML", "Mali"], ["NE", "Niger"], ["GN", "Guinée"], ["FR", "France"], ["BE", "Belgique"], ["CH", "Suisse"], ["CA", "Canada"], ["US", "États-Unis"]];

export const OnlinePayDialog = ({ open, onOpenChange, extract, price, orderRef, offerToken, lieu, onTrack }) => {
  const [f, setF] = useState({ first_name: "", last_name: "", email: "", phone: "", city: "", country: "CM" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const pay = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      onTrack?.("online_pay");
      const { payment_url } = await initPayment({ ...f, slug: extract.slug, ref: orderRef, offer_token: offerToken || null, lieu: lieu || null });
      window.location.assign(payment_url);
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Vérifiez vos informations (e-mail et téléphone)");
      setBusy(false);
    }
  };
  const field = (k, label, props = {}) => (
    <div><label className="text-xs font-body text-[#4A4A4A] mb-1 block">{label}</label><input required value={f[k]} onChange={set(k)} data-testid={`pay-${k}-input`} className={inputCls} {...props} /></div>
  );
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="online-pay-dialog" className="bg-[#FAF9F6] rounded-none border-[#D1CFC7] max-w-md w-[calc(100%-2rem)] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl font-light text-left">Payer en ligne</DialogTitle>
          <DialogDescription className="font-body text-sm text-[#4A4A4A] text-left">« {extract.title} » — version numérique, {price}. Orange Money, MTN MoMo ou carte bancaire.</DialogDescription>
        </DialogHeader>
        <form onSubmit={pay} className="grid grid-cols-2 gap-3">
          {field("first_name", "Prénom")}
          {field("last_name", "Nom")}
          <div className="col-span-2">{field("email", "E-mail (pour recevoir le livre)", { type: "email" })}</div>
          <div className="col-span-2">{field("phone", "Téléphone / WhatsApp", { type: "tel", placeholder: "+237 6…" })}</div>
          {field("city", "Ville")}
          <div><label className="text-xs font-body text-[#4A4A4A] mb-1 block">Pays</label>
            <select value={f.country} onChange={set("country")} data-testid="pay-country-input" className={inputCls}>{COUNTRIES.map(([c, l]) => <option key={c} value={c}>{l}</option>)}</select>
          </div>
          <button type="submit" disabled={busy} data-testid="pay-submit" className="col-span-2 mt-2 bg-[#2C402E] hover:bg-[#1F2D21] text-[#FAF9F6] py-3.5 font-body text-sm tracking-wide flex items-center justify-center gap-2 disabled:opacity-60">
            {busy ? <Loader2 size={16} className="animate-spin" /> : <CreditCard size={16} />} Continuer vers le paiement sécurisé
          </button>
          <p className="col-span-2 text-[11px] font-body text-[#757575] text-center">Paiement sécurisé par CinetPay. Votre livre, marqué à votre nom, arrive par e-mail dès la confirmation.</p>
        </form>
      </DialogContent>
    </Dialog>
  );
};
